import { useState, useEffect } from "react";
import { Phone, Menu, X } from "lucide-react";
import { scrollToSection } from "@/lib/lenis";
import { CONTACT } from "@/lib/contact";

const NAV = [
  { id: "services", label: "Services" },
  { id: "about", label: "About" },
  { id: "testimonials", label: "Reviews" },
  { id: "contact", label: "Contact" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    scrollToSection(id);
    setMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-colors duration-300 ${
        scrolled ? "bg-[#0A1128]/90 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <button
          data-testid="logo-home-btn"
          onClick={() => go("home")}
          className="flex items-center gap-2.5 font-serif text-2xl text-white tracking-tight"
        >
          <img src="/favicon.png" alt="Grow High Accounting logo" className="w-9 h-9 rounded-full" />
          Grow High <span className="text-[#C5A059]">Accounting</span>
        </button>

        <nav className="hidden lg:flex items-center gap-10 font-sans text-base text-slate-200">
          {NAV.map((n) => (
            <button
              key={n.id}
              data-testid={`nav-${n.id}-link`}
              onClick={() => go(n.id)}
              className="hover:text-[#C5A059] transition-colors"
            >
              {n.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={CONTACT.phoneHref}
            data-testid="header-call-btn"
            className="hidden sm:flex items-center gap-2 rounded-full border border-white/30 px-5 py-2 text-base text-white hover:bg-white hover:text-[#0A1128] transition-colors duration-300"
          >
            <Phone size={14} /> Talk to us today
          </a>
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setMenuOpen(!menuOpen)}
            className="lg:hidden text-white p-2"
          >
            {menuOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="lg:hidden bg-[#0A1128] border-t border-white/10 px-6 py-6 flex flex-col gap-5">
          {NAV.map((n) => (
            <button
              key={n.id}
              data-testid={`mobile-nav-${n.id}-link`}
              onClick={() => go(n.id)}
              className="text-left text-slate-200 text-base"
            >
              {n.label}
            </button>
          ))}
          <a href={CONTACT.phoneHref} data-testid="mobile-call-btn" className="text-[#C5A059] text-base">
            {CONTACT.phoneDisplay}
          </a>
        </div>
      )}
    </header>
  );
};
